<div class="health-container">
  <div class="main-container">
    <div class="main-content">
      <div class="list-header">
        <button class="back-btn" (click)="goBack()">
          <i class="fas fa-chevron-left"></i>
        </button>
        <!-- <h2 *ngIf="
        (allergyList?.length || 
        insuranceList?.length || 
        immunizationList.length ||
        medconList.length || 
        famHistoryList.length ) == 0">{{getLogTitle(selected)}}</h2>
         <h2 *ngIf="
        (allergyList?.length || 
        insuranceList?.length || 
        immunizationList.length ||
        medconList.length || 
        famHistoryList.length ) > 0">List Of {{headerTitle}}</h2> -->
                
        <h2>{{getLogTitle(selected)}}</h2>
      </div>

      <div class="document-list">
        <div class="search-section" *ngIf="
        (allergyList?.length || 
        insuranceList?.length || 
        immunizationList.length ||
        medconList.length || 
        famHistoryList.length ) > 0">
          <div class="search-container">
            <i class="material-icons">search</i>
            <input class="search-text" type="text"  [(ngModel)] = searchText  #filter placeholder="Search For {{headerTitle}}...">
          </div>
        </div>


        <h2 class="listMed" *ngIf="insuranceList.length> 0">List Of Insurances ( {{insuranceList.length}} )</h2>
        <h2 class="listMed" *ngIf="allergyList.length> 0">List Of Allergy ( {{allergyList.length}} )</h2>
        <h2 class="listMed" *ngIf="immunizationList.length> 0">List Of Immunizations ( {{immunizationList.length}} )</h2>
        <h2 class="listMed" *ngIf="medconList.length> 0">List Of Medical Conditions ( {{medconList.length}} )</h2>
        <h2 class="listMed" *ngIf="famHistoryList.length> 0">List Of Family History ( {{famHistoryList.length}} )</h2>

        <!-- Only show one list at a time -->
        <ng-container [ngSwitch]="true">
          <!-- Allergy List -->
          <ng-container *ngSwitchCase="allergyList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of allergyList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon"><img class="imghel" src="assets/images/health/icons/coronavirus_3276397 1.svg"/></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.allergicTo | titlecase  }}</h3>
                    <p class="med-info">{{ med.allergicReaction.join(', ') }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuAllergy">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuAllergy="matMenu">
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <div class="card-footer allr">
                  <div class="severity">
                    <span class="severity-indicator"
                          [ngClass]="{
                            'high': med.severity?.toLowerCase() === 'high',
                            'medium': med.severity?.toLowerCase() === 'medium',
                            'low': med.severity?.toLowerCase() === 'low'
                          }">
                    </span>
                    <span class="severity-label">{{ med.severity | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Insurance List -->
          <ng-container *ngSwitchCase="insuranceList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of insuranceList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon"><img class="imghel" src="assets/images/health/icons/file_11677433 1.svg"/></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.insuranceCompany | titlecase }}</h3>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuInsurance">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuInsurance="matMenu">
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <div class="card-footer">
                  <div class="severity">
                    <span class="severity-indicator"
                          [ngClass]="{
                            'low': med.status?.toLowerCase() === 'active',
                            'medium': med.status?.toLowerCase() === 'inactive'
                          }">
                    </span>
                    <span class="severity-label">{{ med.status | titlecase }}</span>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Immunization List -->
          <ng-container *ngSwitchCase="immunizationList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of immunizationList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon"><img class="imghel" src="assets/images/health/healthlogico/immulisticon.png"/></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.vaccineName | titlecase }}</h3>
                    <p class="med-info">{{ med.adminDate }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuImmunization">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuImmunization="matMenu">
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>

                <div class="card-footer" *ngIf="med.nextDueDate">
                  <div class="status-badge">
                    Next Due on {{ convertDateFormat(med.nextDueDate) }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Family History -->
          <ng-container *ngSwitchCase="famHistoryList.length > 0">
            
          </ng-container>

          <!-- Medical Conditions -->
          <ng-container *ngSwitchCase="medconList.length > 0">
            <div class="medication-grid">
              <div class="medication-card" *ngFor="let med of medconList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon"><img class="imghel" src="assets/images/health/icons/med-condlt.png" /></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.conditionName | titlecase }}</h3>
                    <p class="med-info">{{ med.yearOfDiagnosis }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuMedCond">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuMedCond="matMenu">
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Empty State -->
          <!-- <ng-container *ngSwitchDefault>
          <div class="empty-state">
            <img *ngIf="selected === 'allergy'" class="noimg" src="assets/images/health/icons/allergies 1(1).svg" />
            <img *ngIf="selected === 'insurance'" class="noimg" src="assets/images/health/icons/insurance ico1.svg" />
            <img *ngIf="selected === 'familyhistory'" class="noimg" src="assets/images/health/healthlogico/familyhispng.png" />
            <img *ngIf="selected === 'medicalcondition'" class="noimg" src="assets/images/health/healthlogico/medicalconpng.png" />
            <img *ngIf="selected === 'immunization'" class="noimg" src="assets/images/health/healthlogico/immunizpng.png" />

            <h3>Manage {{selected | titlecase}}</h3>
            <p>Keep track of your {{selected}}</p>
            <button class="add-new-btn" mat-raised-button (click)="openDialog()">
              <span class="btn-text"> Add {{selected | titlecase}}</span>
            </button>
          </div>
          </ng-container> -->

          <ng-container *ngSwitchDefault>
            <div class="empty-state-card">
              <!-- Log Img -->
              <img *ngIf="selected" class="empty-icon" [src]="logIcons[selected]" alt="Icon"/>

               <!-- Log Title -->
               <h3>Manage {{ getLogTitle(selected) }}</h3>

              <!-- Logs Div -->
              <!-- insurance -->
              <div class="empty-description" *ngIf="selected === 'insurance'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/business chart with dollar.svg" alt="Track" />
                  <span class="trackTxt">Keep track of your {{selected}}</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/icons/data medis.svg" alt="Check" />
                  <span class="trackTxt">Check your coverage</span>
                </div>
              </div>
              <!-- familyhistory -->
              <div class="empty-description" *ngIf="selected === 'familyhistory' || selected === 'medicalcondition'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/dna.svg" alt="Track" />
                  <span class="trackTxt">Track inherited health conditions</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/family_16004600 1.svg" alt="Check" />
                  <span class="trackTxt">Stay informed for preventive care</span>
                </div>
              </div>
              
              <!-- allergy -->
              <div class="empty-description" *ngIf="selected === 'allergy'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/suntik.svg" alt="Track" />
                  <span class="trackTxt">Keep track of your allergies</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/masker.svg" alt="Check" />
                  <span class="trackTxt">Avoid allergic reactions</span>
                </div>
              </div>

              <!-- immunization -->
              <div class="empty-description" *ngIf="selected === 'immunization'">
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/suntik.svg" alt="Track" />
                  <span class="trackTxt">Stay updated on your vaccines</span>
                </div>
                <div class="desc-item">
                  <img src="assets/images/health/homeimg/masker.svg" alt="Check" />
                  <span class="trackTxt">Check your coverage</span>
                </div>
              </div>
              <!-- Logs Div ends here -->

              <!-- Log Button -->
              <button class="add-new-btn" mat-raised-button (click)="openDialog()">
                Add {{ getBtnTitle(selected) }}
              </button>    
              <!-- Log Button -->

            </div>
          </ng-container>


        </ng-container>

        <!-- Floating Action Button -->
        <button class="fab-button" (click)="openDialog()" *ngIf="(allergyList?.length || insuranceList?.length || immunizationList.length || medconList.length || famHistoryList.length ) > 0"> 
          <img *ngIf="selected === 'insurance'" class="dialog-icon" src="assets/images/medical.png"/>
          <img *ngIf="selected === 'familyhistory'" class="dialog-icon" src="assets/images/health/icons/family-insurance 1.svg"/>
          <img *ngIf="selected === 'medicalcondition'" class="dialog-icon" style="margin-top: 5px;" src="assets/images/health/icons/med-rep.png"/>
          <img *ngIf="selected === 'allergy'" class="dialog-icon" style="margin-top: 5px;" src="assets/images/health/icons/allergies 1.svg"/>
          <img *ngIf="selected === 'immunization'" class="dialog-icon" style="margin-top: 5px;" src="assets/images/health/icons/immune-system 1.svg"/>
        </button>
        <!-- Floating Action Button -->
      </div>
    </div>
  </div>
</div>

<div class="medication-grid">
              <div class="medication-card" *ngFor="let med of famHistoryList | filterAll:searchText">
                <div class="card-header">
                  <div class="med-icon"><img class="imghel" src="assets/images/health/icons/cardiovascular_18593605 1.svg"/></div>
                  <div class="med-title-group">
                    <h3 class="med-name">{{ med.conditionName }}</h3>
                    <p class="med-info">{{ med.relationship.join(', ') | titlecase  }}</p>
                  </div>
                  <div class="card-actions">
                    <button mat-icon-button [matMenuTriggerFor]="menuFamHistory">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menuFamHistory="matMenu">
                      <button mat-menu-item (click)="onEdit(med)">
                        <img class="imgbtn" src="assets/images/health/icons/iconamoon_edit-light.svg" />&nbsp;
                        <span>Edit</span>
                      </button>
                      <button mat-menu-item (click)="onDelete(med)">
                        <img class="imgbtn" src="assets/images/health/icons/fluent_delete-28-regular.svg" />&nbsp;
                        <span>Delete</span>
                      </button>
                    </mat-menu>
                  </div>
                </div>
              </div>
            </div>
